import { generatePopupConfig } from '@/features/Popup/helpers/generatePopupConfig.tsx';
import {
  DYNAMIC_POPUP_TYPES,
  ERROR_TYPE,
  GEOLOCATION_STEPS,
  POPUP_TYPES,
} from '@/features/Popup/constants.ts';
import { GeolocationStepsType } from '@/features/Popup/types';
import { usePopup } from '@/features/Popup/usePopup.ts';

export const useShowDebugPopups = () => {
  const { showPopup } = usePopup();
  const showProviderErrorPopup = (errorType: string) => {
    showPopup(
      generatePopupConfig(POPUP_TYPES.PROVIDER, {
        errorConfig: {
          errorType:
            errorType as unknown as import('@/features/Popup/types').GameErrorType,
          errorCode: 'TEST-001',
        },
      }),
      errorType,
    );
  };

  const showGeolocationRefreshPopup = (step: GeolocationStepsType) => {
    showPopup(
      generatePopupConfig(DYNAMIC_POPUP_TYPES.GEOLOCATION_REFRESH, { step }),
      DYNAMIC_POPUP_TYPES.GEOLOCATION_REFRESH,
    );
  };

  const showGeolocationRefreshLoadingPopup = () =>
    showGeolocationRefreshPopup(GEOLOCATION_STEPS.LOADING);

  const showGeolocationRefreshSuccessPopup = () =>
    showGeolocationRefreshPopup(GEOLOCATION_STEPS.SUCCESS);

  const showGeolocationRefreshErrorPopup = () =>
    showGeolocationRefreshPopup(GEOLOCATION_STEPS.ERROR);

  // Function to show exit popup
  const showExitPopup = () => {
    showPopup(generatePopupConfig(POPUP_TYPES.EXIT), POPUP_TYPES.EXIT);
  };

  // Function to show exit recently played popup
  const showExitRecentlyPopup = () => {
    showPopup(
      generatePopupConfig(POPUP_TYPES.EXIT_RECENTLY),
      POPUP_TYPES.EXIT_RECENTLY,
    );
  };

  // Function to show SWJ popup
  const showSWJPopup = () => {
    showPopup(generatePopupConfig(POPUP_TYPES.SWJ), POPUP_TYPES.SWJ);
  };

  // Function to show reality check via the dev trigger (CPE RG UM modal).
  const showRealityCheckPopup = () => {
    const trigger = (
      window as Window & {
        __triggerRealityCheck?: (showModal?: boolean) => void;
      }
    ).__triggerRealityCheck;
    trigger?.();
  };

  // Function to show free spin dialog choose popup
  const showFreeSpinDialogChoosePopup = () => {
    showPopup(
      generatePopupConfig(POPUP_TYPES.PROVIDER, {
        errorConfig: {
          errorType: ERROR_TYPE.FREE_SPIN_DIALOG_CHOOSE,
          errorParameters: ['Option 1', 'Option 2', 'Option 3'],
        },
      }),
      POPUP_TYPES.PROVIDER,
    );
  };

  // Function to show free spin dialog start popup (Free Spins mode / Cash mode)
  const showFreeSpinDialogStartPopup = () => {
    showPopup(
      generatePopupConfig(POPUP_TYPES.PROVIDER, {
        errorConfig: {
          errorType: ERROR_TYPE.FREE_SPIN_DIALOG_START,
        },
      }),
      POPUP_TYPES.PROVIDER,
    );
  };

  // Function to show free spin dialog finish popup (Play for Real)
  const showFreeSpinDialogFinishPopup = () => {
    showPopup(
      generatePopupConfig(POPUP_TYPES.PROVIDER, {
        errorConfig: {
          errorType: ERROR_TYPE.FREE_SPIN_DIALOG_FINISH,
        },
      }),
      POPUP_TYPES.PROVIDER,
    );
  };

  const popupQueue = () => {
    showProviderErrorPopup(ERROR_TYPE.INSUFFICIENT_FUNDS);
    showProviderErrorPopup(ERROR_TYPE.GENERIC);
    showExitPopup();
    showSWJPopup();
    showRealityCheckPopup();
    showExitRecentlyPopup();
  };

  return {
    showProviderErrorPopup,
    showExitPopup,
    showExitRecentlyPopup,
    showSWJPopup,
    showRealityCheckPopup,
    showFreeSpinDialogChoosePopup,
    showFreeSpinDialogStartPopup,
    showFreeSpinDialogFinishPopup,
    showGeolocationRefreshLoadingPopup,
    showGeolocationRefreshSuccessPopup,
    showGeolocationRefreshErrorPopup,
    popupQueue,
  };
};
